import React, { FC } from 'react';
import Pagination from '@material-ui/lab/Pagination/Pagination';
import { Row } from './Row';

interface PageIndexProps {
  index: number;
  indexesCount: number;
  justifyContent?: string;
  margin?: string;
  onChange: (e: React.ChangeEvent<unknown>, v: number) => void;
}

export const PageIndex: FC<PageIndexProps> = ({ index, justifyContent, margin, indexesCount, onChange }) =>
  indexesCount <= 1 ? (
    <Row margin={margin} />
  ) : (
    <Row margin={margin} justifyContent={justifyContent}>
      <Pagination
        color="primary"
        count={indexesCount}
        page={index}
        onChange={onChange}
        showFirstButton
        showLastButton
      />
    </Row>
  );
